import { render, staticRenderFns } from "./ShareLeads.vue?vue&type=template&id=2b130482"
import script from "./ShareLeads.vue?vue&type=script&lang=js"
export * from "./ShareLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports